import { render, staticRenderFns } from "./reportInterpretation2.vue?vue&type=template&id=370326d0&scoped=true"
import script from "./reportInterpretation2.vue?vue&type=script&lang=js"
export * from "./reportInterpretation2.vue?vue&type=script&lang=js"
import style0 from "./reportInterpretation2.vue?vue&type=style&index=0&id=370326d0&prod&lang=less&scoped=true"
import style1 from "./reportInterpretation2.vue?vue&type=style&index=1&id=370326d0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370326d0",
  null
  
)

export default component.exports